export default {
  auth: {
    email: "E-mail",
    password: "Password",
    logout: "Logout",
    sign_in: "Login",
    login_screen: "login screen",
    back_to_sign_in: "Back to login",
    reset_password: "Reset Password",
    reset_password_code: "Reset Password Code",
    forget_password: "Forget Password",
    new_password: "New Password",
    re_new_password: "Re New Password",
    login_failed: "Identity not found",
    change_password: "Change Password",
    continue: "Continue",
    password_change_successfully: "Your password has been changed successfully",
    showcase: {
      welcome: "Welcome^3000",
      cloud: "Next generation identification and management cloud platform^4000",
      identify: "It lets you identify, track and manage your workforce^1000 easy and secure^4000",
      manage: "You can manage anytime and anywhere you like^4000",
      freedom: "You have freedom^3000 to see all your system^3000"
    },
    login_with_amazon: "Login With Amazon",
    login_with_google: "Login With Google",
    update_password: "Update Password",
    email_not_found: "This email address was not found",
    invalid_reset_token: "Invalid reset code",
    password_reset_code_sent_to_email: "Your password reset code has been sent to your e-mail address",
    passwordExpireNotificationMessage:
      "There are 0 day left until your password expires | There are 1 day left until your password expires | There are {count} days left until your password expires"
  }
};
